<template>
  <container :class="['page-wrapper']">
    <flex :spacing="3">
      <flex-col :span="24">
        <test-toolbar />
      </flex-col>
      <flex-col equal-height xs24 :span="12" v-for="(item, index) in breadcrumbs" :key="index">
        <card full-height>
          <card-title v-html="item.title" :bg-color="$root.colors.primary" :bg-color-lightness="$root.colors.bgColorLightness" color="white" />
          <card-text>
            <breadcrumbs
              :tag="item.tag"
              :delimiter="item.delimiter"
              :last-item-disabled="item.lastItemDisabled"
              :target="item.target"
              :underline="true"
              :color-lightness="$root.colors.bgColorLightness"
              :color="$root.colors.primary"
              :align="item.align">
              <breadcrumbs-item
                v-for="(link, i) in breadcrumbItems"
                :to="link.to"
                :title="link.label"
                :key="i"
              >{{ link.label }}</breadcrumbs-item>
            </breadcrumbs>
          </card-text>
        </card>
      </flex-col>
    </flex>
  </container>
</template>
<script>
import methods from '../../mixins/methods'

export default {
  name: 'PageBreadcrumbs',
  mixins: [
    methods
  ],
  data () {
    return {
      breadcrumbs: [],
      breadcrumbItems: []
    }
  },
  mounted () {
    this.getExternalData('breadcrumbs.json', 'breadcrumbs', null, () => {
      this.getExternalData('breadcrumbs-items.json', 'breadcrumbItems')
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/ui/breadcrumbs.vue